import axios, {
  AxiosError,
  AxiosRequestHeaders,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
import Cookies from "js-cookie";
import { API_BASE_URL } from ".";
import { handleApiError } from "../utils/handleApiError";

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

axiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // Only access cookies on client side
    if (typeof window !== "undefined") {
      const token = Cookies.get("mci_elecamp_token");

      const headers = {
        ...(config.headers || {}),
        ...(token ? { Authorization: `token ${token}` } : {}),
      };

      config.headers = headers as AxiosRequestHeaders;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    // silent mode => dont show toast
    handleApiError(error, true);
    return Promise.reject(error);
  }
);

export default axiosInstance;
